// extracted by mini-css-extract-plugin
export var Description = "K_cr";
export var EditorialGuidelines = "K_cm";
export var GuideLines = "K_cs";
export var Title = "K_cq";
export var container = "K_cn";
export var leftColumn = "K_cp";
export var rightColumn = "K_ct";